export default "__VITE_ASSET__CRZtaUwJ__"